var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress"},_vm._l((_vm.arr),function(item,index){return _c('div',{key:item,staticClass:"progress-item",class:{
      'progress-item--first' : index === 0,
      'progress-item--end' : index === _vm.arr.length - 1,
      'progress-item--select' : index === _vm.activeIndex
    }},[_vm._m(0,true),_vm._m(1,true),_c('div',{staticClass:"progress-item__text"},[_vm._v(_vm._s(item))])])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-item-top"},[_c('div',{staticClass:"progress-item-top__left"}),_c('div',{staticClass:"progress-item-top__right"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-item-bottom"},[_c('div',{staticClass:"progress-item-bottom__left"}),_c('div',{staticClass:"progress-item-bottom__right"})])
}]

export { render, staticRenderFns }